export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/icon-splash-top-text-afe37b7d091a461e2d1dbd765ce0c39b.svg";